import { render, staticRenderFns } from "./ChatWorkbenchHost.vue?vue&type=template&id=1a68674f&scoped=true"
import script from "./ChatWorkbenchHost.vue?vue&type=script&lang=js"
export * from "./ChatWorkbenchHost.vue?vue&type=script&lang=js"
import style0 from "./ChatWorkbenchHost.vue?vue&type=style&index=0&id=1a68674f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68674f",
  null
  
)

export default component.exports